module.exports = __webpack_public_path__ + "img/gap_icon.99e934f8.png";